export interface EnvContext {
  release: string;
  platform: string;
  arch: string;
  os_version: string;
  electron_version: string;
  chromium_version: string;
  node_version: string;
}

interface UserAgentBrand {
  brand: string;
  version: string;
}

interface UserAgentData {
  platform?: string;
  brands?: UserAgentBrand[];
}

function userAgentData(): UserAgentData | undefined {
  return (navigator as Navigator & { userAgentData?: UserAgentData })
    .userAgentData;
}

function detectPlatform(): string {
  const uaPlatform = userAgentData()?.platform;
  if (uaPlatform) return uaPlatform;
  const ua = navigator.userAgent;
  if (/Mac/.test(ua)) return 'macos';
  if (/Win/.test(ua)) return 'windows';
  if (/Linux|X11/.test(ua)) return 'linux';
  return '';
}

function detectChromiumVersion(): string {
  const brands = userAgentData()?.brands;
  const chromium = brands?.find((b) => /Chromium|Google Chrome/.test(b.brand));
  if (chromium) return chromium.version;
  const match = /Chrom(?:e|ium)\/(\d+(?:\.\d+)*)/.exec(navigator.userAgent);
  return match ? match[1] : '';
}

function detectOsVersion(): string {
  const ua = navigator.userAgent;
  const mac = /Mac OS X ([0-9_.]+)/.exec(ua);
  if (mac) return mac[1].replace(/_/g, '.');
  const win = /Windows NT ([0-9.]+)/.exec(ua);
  if (win) return win[1];
  const android = /Android ([0-9.]+)/.exec(ua);
  if (android) return android[1];
  return '';
}

let cached: EnvContext | null = null;

export function getEnvContext(): EnvContext {
  if (cached) return cached;
  // electron_version/node_version stay '' here; kept for schema parity with Electron (Redshift)
  cached = {
    release: window.$app_rev ?? '',
    platform: detectPlatform(),
    arch: '', // not exposed to the browser without UA-CH high-entropy hints
    os_version: detectOsVersion(),
    electron_version: '',
    chromium_version: detectChromiumVersion(),
    node_version: '',
  };
  return cached;
}
